import React, { useContext, useState } from 'react';
import whitelogo from '../assets/img/logo.png';
import loginimg from '../assets/img/logo-img-slice.png';
import athleticimg from '../assets/img/authentic_logo-white.png';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import PersonIcon from '@mui/icons-material/Person';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import {
  Navigate,
  useNavigate,
  Link
} from "react-router-dom";
import { useDispatch } from "react-redux";
import { AppContext } from '../context';

import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
// modal code start

import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';

import IconButton from '@mui/material/IconButton';
import CloseIcon from "@mui/icons-material/Close";

import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import LockIcon from '@mui/icons-material/Lock';
import MailIcon from '@mui/icons-material/Mail';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import trainingManual from '../assets/Sports_Athletic_Consent_Platform.v2.pdf';
import  secureLocalStorage  from  "react-secure-storage";

// modal code end
 // reset psd code modal end
      const BootstrapDialog = styled(Dialog)(({ theme }) => ({
        '& .MuiDialogContent-root': {
          padding: theme.spacing(2),
        },
        '& .MuiDialogActions-root': {
          padding: theme.spacing(1),
        },
      }));
      
      function BootstrapDialogTitle(props) {
        const { children, onClose, ...other } = props;
      
        return (
          <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
              <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </DialogTitle>
        );
      }

function Login () {
    React.useEffect(() => {
        if (document.body.classList.contains('adminbody_bg')) {
          document.body.classList.remove('body');
    
        }
        document.body.classList.add('adminbody_bg');
    
      });


      const [openLog, setOpenLog] = React.useState(false);
   
// password section code start
const [openEye, setOpenEye] = React.useState(false);
const handleClickOpenEye = () => {
    setPasswordparent(false);
    setOpenEye(true);
    
}
const handleClickCloseEye = () => {
    setPasswordparent(true);
    setOpenEye(false);
 
}

const [user, setUser] = useState({ username: '', password: '', ipuser: '' });
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [loader, setLoader] = useState(false);
  const [password, setPassword] = useState(true);
  const { storage } = useContext(AppContext);
  const { dispatchStorageEvent } = useContext(AppContext);
  const [erroruserid, setErrorUserid] = useState(false);
  const [errorpassword, setErrorPassword] = useState(false);
  const [loginval, setloginval] = useState(0);
  const [effectiveDate, setEffectiveDate] = useState({ value: "", error: "" });

  const [parent, setParent] = useState({ username: '', password: '' });
   const [successparentMsg, setSuccessparentMsg] = useState('');
  const [errorparentMsg, setErrorparentMsg] = useState('');
  const [loaderparent, setparentLoader] = useState(false);
  const [passwordparent, setPasswordparent] = useState(true);
  const [erroruserparentid, setErrorUserparentid] = useState(false);
  const [errorpasswordparent, setErrorPasswordparent] = useState(false);
   const handleOpenLog = () => setOpenLog(true);
      const handleCloselog = () => 
      {
             setErrorUserparentid(false);
             setErrorPasswordparent(false);

        setParent({ username: '', password: '' });
        setOpenLog(false);
    } 

    //   forgot psd code modal start
    
const [forgotmail, setForgotmail] = useState('');
const [successMsgforgot, setSuccessMsgforgot] = useState('');
  const [errorMsgforgot, setErrorMsgforgot] = useState('');
  const [loaderforgot, setLoaderforgot] = useState(false);
    const [openForgot, setOpenForgot] = React.useState(false);
    const handleOpenForgot = () => 
    {setForgotmail('');
     setSuccessMsgforgot('');
    setErrorMsgforgot('');
        setOpenForgot(true);
        setOpenLog(false);
    }
    const handleCloseForgot = () =>{

        setParent({ username: '', password: '' });
        setOpenForgot(false);
    } 
    
    // forgot psd code modal end

    // reset psd code modal start
    const [openReset, setOpenReset] = React.useState(false);
    const handleOpenReset = () => 
    {
        setOpenReset(true);
        setOpenForgot(false);
    }
    const handleCloseReset = () => setOpenReset(false);
    
   
  const handleChangeChilddate = (event) => {
    setErrorPassword(false);
    if (event != '') {
      setEffectiveDate({ value: event.$d, error: "" });
    } else {
      setEffectiveDate({ value: "", error: "Please select date" });

    }
  }
  const Axios = axios.create({
    baseURL: storage[0].backEndUrl
    // baseURL: process.env.REACT_APP_ENV_URL
  });
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);

  const handleClick = () => {
    setPassword(!password);
    setVisible(true);
  }
  const handleVisibleClick = () => {
    setPassword(true);
    setVisible(false);
  }

  const [loading, setLoading] = useState(false);
  const handleKeypress = (e)  => {

    //it triggers by pressing the enter key
    if (e.which === 13) {
       e.preventDefault();
      handleSubmit();

    }
  };
     const changeUserDataFor = (e) => {
    setForgotmail(e.target.value);
  }


const handleKeypressfor = e => {

    //it triggers by pressing the enter key
    if (e.which === 13) {
       e.preventDefault();
      handleSubmitfor();

    }
  };


  const handleSubmitfor = (event) => {

    setSuccessMsgforgot('');
    setErrorMsgforgot('');
    
    if (forgotmail == '') { setErrorMsgforgot('Please Enter Email'); return false; }
    
    setLoaderforgot(true);
   
    Axios.post(`/forgot_passowrd`, { email: forgotmail})
      .then(res => {
        console.log(res.data);

        if (res.data.status == true) {
          console.log(res.data.data);
         setForgotmail('');
          setSuccessMsgforgot(res.data.data);

                    setLoaderforgot(false);
                  
                    

setTimeout(function () {
              setSuccessMsgforgot('');
              setOpenForgot(false);
   
              }, 3000);



                }
                else {
                    
                    setErrorMsgforgot(res.data.data);
                    setLoaderforgot(false);
                }
            });
    }
  const changeUserData = (e) => {
    setErrorUserid(false);
    setErrorPassword(false);
     setErrorMsg('');

    var user_temp = { ...user };
    if (e.target.name == 'username') user_temp.username = e.target.value;
    // if (e.target.name == 'password') user_temp.password = e.target.value;
    setUser(user_temp);
  }



  const handleSubmit = (event) => {

    setErrorMsg('');
    setSuccessMsg('');
    setErrorUserid(false);
    setErrorPassword(false);
    if (user.username == '') { setErrorUserid(true); return false; }
    if (user.password == '') { setErrorPassword(true); return false; }
    setLoader(true);
    const myArray = user.password.split("/");
  
    var month = myArray[0];
    var day = myArray[1];
    var year = myArray[2];
    var daten = year + '-' + month + '-' + day;
    // const date = new Date(effectiveDate.value);
    // const day = date.getDate().toString().padStart(2, "0");
    // const month = (date.getMonth() + 1).toString().padStart(2, "0");
    // const year = date.getFullYear().toString();
    // const fromDate = `${day}-${month}-${year}`;
    // let fromDate1 = `${year}-${month}-${day}`;

    Axios.post(`/validation`, { studentid: user.username, dob:daten })
      .then(res => {
        console.log(res.data);

        if (res.data.status == true) {
          console.log(res.data.data);
          storage[0].userdata = res.data.data;
          secureLocalStorage.setItem("userdata", JSON.stringify(res.data.data));
          secureLocalStorage.setItem('username', res.data.data.stuid);

          dispatchStorageEvent(storage);
          setSuccessMsg('Login Successfully!');

                    setLoader(false);
                    console.log(res.data.data.parent_name);
                    if(res.data.data.status != 'approved'){
                       setloginval(1); 
                   }else{
                    setloginval(2);
                   }
                    





                }
                else {
                    setloginval(0);
                    setErrorMsg(res.data.data);
                    setLoader(false);
                }
            });
    }


  const handleKeypressparent = e => {

    //it triggers by pressing the enter key
    if (e.which === 13) {
      handleSubmitParent();

    }
  };
  const changeParentData = (e) => {
    setErrorUserparentid(false);
    setErrorPasswordparent(false);
    var user_temp = { ...parent };
    if (e.target.name == 'username') user_temp.username = e.target.value;
    if (e.target.name == 'password') user_temp.password = e.target.value;
    setParent(user_temp);
  }




  const handleSubmitParent = (event) => {

    setErrorparentMsg('');
    setSuccessparentMsg('');
    setErrorUserparentid(false);
    setErrorPasswordparent(false);
    if (parent.username == '') { setErrorUserparentid(true); return false; }
    if (parent.password == '') { setErrorPasswordparent(true); return false; }
    setparentLoader(true);
   

    Axios.post(`/parents_login`, { email: parent.username, password:parent.password  })
      .then(res => {
        console.log(res.data);

        if (res.data.status == true) {
          console.log(res.data.data);
          storage[0].userdata = res.data.data;
          secureLocalStorage.setItem("userdata", JSON.stringify(res.data.data));
          secureLocalStorage.setItem('username', res.data.data.stuid);
          secureLocalStorage.setItem('userlogin', res.data.data.stuid);

          dispatchStorageEvent(storage);
          setSuccessparentMsg('Login Successfully!');
          secureLocalStorage.setItem("studenentformdata", JSON.stringify(res.data.studentdata));
                    setparentLoader(false);
                   setloginval(3); 






                }
                else {
                    setloginval(0);
                    setErrorparentMsg(res.data.data);
                    setparentLoader(false);
                }
            });
    }

                                 const handleNumChange = (event) => {
    console.log(event.target.value);
  setErrorUserid(false);
    setErrorPassword(false);
    var user_temp = { ...user };
const charCode = event.which || event.keyCode;

    var value = event.target.value;

 if(value.length<=10){
   user_temp.password = value;
 }
     
      setUser(user_temp);
    
  }
function handleKeyAccountPress(event) {
    const charCode = event.which || event.keyCode;

    if (charCode != 43 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      // The pressed key is not a number
 setErrorMsg('Only Numbers are allowed');
      event.preventDefault();
    }
  }

  const handleAccountChange = (event) => {
    setErrorMsg('');

     console.log(event.target.value);
  setErrorUserid(false);
    setErrorPassword(false);
    var user_temp = { ...user };
const charCode = event.which || event.keyCode;

      if (user_temp.password && (user_temp.password.length == 2 || user_temp.password.length == 5 )) {
              
              user_temp.password  = user_temp.password + '/';
            }
user_temp.password = user_temp.password;
   setUser(user_temp);
    

  }
  
    if (loginval == 1) {
        return <Navigate to='/registration' />;
    }
     if (loginval == 2) {
        return <Navigate to='/password' />;
    }
    if (loginval == 3) {
        return <Navigate to='/instruction' />;
    }
// password section code end


  const handleDownloadTraning = () => {
    const link = document.createElement('a');
    link.href = trainingManual;
    link.download = 'Sports_Athletic_Consent_Platform.v2.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  }

  return (
    <>
   <div className='login-sec'>
    <div className='container-fluid'>
        <div className='row'>
            <div className='login-header'>
                <div className='col-md-12'>
                        <img src={whitelogo} alt='logo' />
                </div>
            </div>
            </div>

            <div className='row'>
                <div className='col-md-12'>
                    <div className='login-content-sec'>
                        <h2>Parent Permission/Consent Form for Athletic Participation</h2>
                        <p>Find important Athletics forms and documents, including the Pre Participation Physical Evaluation Form, 
                            Consent Form,  Athlete with Special Needs Supplemental History Form, Parent/Guardian Acknowledgement Form</p>
                    </div>
                </div>
            </div>


           <div className='login-sec-new login-sec-newss'>
      {/* <div className='container'> */}
            <div className='row'>
               {/* <div className="col-md-6 padding-right">
                    <div className='login-img'>
                        <img src={loginimg} />
                    </div>
                </div>*/}

                <div className="col-md-12 padding-left">
                <div className='login-sec-page login-sec-pagess'>
                {/* <img src={logoimagewhite} />
                <p>Athletics Club</p> */}
                 <div className='login-img'>
                        <img src={athleticimg} />
                    </div>
               <div className='login-secs login-secsss login-secssss'>
                    <Box
                    component="form"
                    sx={{
                        '& > :not(style)': { m: 1, width: '90%', margin: '0 auto' },
                    }}
                    noValidate
                    autoComplete="off"
                    >

                    <TextField id="standard-basic" label="Student Id" variant="outlined"
                          value={user.username} onChange={changeUserData} onKeyPress={handleKeypress}
                  name="username"
                  error={erroruserid}
                  helperText={` ${erroruserid == true ? 'Please enter student id!' : ''}`} />
                  <span className='login-icon lgn-icn'><PersonIcon /></span>
                    </Box>
                </div>

                 <div className='login-secs login-secsss login-secssss'>
                    <Box
                    component="form"
                    sx={{
                        '& > :not(style)': { m: 1, width: '90%', margin: '0 auto' },
                    }}
                    noValidate
                    autoComplete="off"
                    >

                    <TextField id="standard-basic" label="Student DOB" variant="outlined"
                        type={password ? 'text' : 'text'} 
                  name="password"
                  value={user.password} 
                      onChange={(e) => handleNumChange(e)}
                            onKeyPress={(e) => {handleAccountChange(e);handleKeypress(e);handleKeyAccountPress(e)}}
                            // onKeyDown={(e) => handleKeyAccountDown(e)}


                  error={errorpassword}  placeholder='MM/DD/YYYY'

                  helperText={` ${errorpassword == true ? 'Please enter DOB!' : ''}`} />
                     <span className='login-icon lgn-icn'><CalendarMonthIcon /></span>
                    </Box>
                </div>
                <div className='login-submit'>

             <button className='btn btn-login btn-login-sumt btn-nsd-sbmit' onClick={handleSubmit}>SUBMIT

               {
                  loader != '' ?
                    <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff", position: 'absolute', marginTop: '3px' }} />
                    : ''

                }</button>
               <p className='login-sec-nse' onClick={handleDownloadTraning}>Download Training Manual</p> 
                {/* <p className='login-sec-nse' onClick={handleOpenLog}>LOGIN</p>*/}
 {
              loader != '' ? <div className="success-msg success-login">
                <p className="success-msg success-login">Please wait while we get you access to the system</p>

              </div> : <div className="success-msg success-login">
                <p className="success-msg success-login" style={{ visibility: 'hidden' }} >Please wait while we fetch your data</p>
              </div>
            }

            {
              successMsg != '' ? <div className="success-msg success-login">
                <p className="success-msg success-login">{successMsg}</p>
              </div> : ''
            }


            {
              errorMsg != '' ? <div className="error-msg error-login" >
                <p className="error-msg error-login">{errorMsg}</p>
              </div> : <div className="error-msg error-login" style={{ visibility: 'hidden' }} >
                <p className="error-msg error-login">Wrong credentials!</p>
              </div>
            }
             

             
              </div>

                </div>
                </div>
            </div>
        </div>
        <div className='login-belw-sec'>
            <div className='row'>
                    <div className="col-md-12">
                        <p>As a next step you will be asked to register yourself and create an account.
Your email will be verified to help you login securely in future</p>
                        </div>
            </div>
        </div>

        </div>
   </div>
   
        {/* modal section start */}
       
        <BootstrapDialog
          onClose={handleCloselog}
          aria-labelledby="customized-dialog-title"
          open={openLog} className="route-view copy-view logout-view login-modal">
          <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleCloselog}>
            {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <Typography gutterBottom>
              <div className='copy-sec-modal logout-sec-modal add-club-sec' style={{ paddingTop: '0px' }}>
                {/* <h2 style={{color:'#57585A',paddingTop:'0px'}}>Logout</h2> */}
              
                <h2>Parents Login</h2>

                <div className='login-mdl-sec'>

                <div className='login-secs modl-login login-secssss'>
                    <Box
                    component="form"
                    sx={{
                        '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                    }}
                    noValidate
                    autoComplete="off"
                    >

                    <TextField id="standard-basic" label="Email Id" variant="outlined"
                          value={parent.username} onChange={changeParentData} onKeyPress={handleKeypressparent}
                  name="username"
                  error={erroruserparentid}
                  helperText={` ${erroruserparentid == true ? 'Please enter Email!' : ''}`} 
                                  />
                    <span className='login-icon mod-login-icn'><MailIcon /></span>
                    </Box>
                </div>

                <div className='login-secs modl-login login-secssss'>
                    <Box
                    component="form"
                    sx={{
                        '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                    }}
                    noValidate
                    autoComplete="off"
                    >

                    <TextField id="standard-basic" label="Password" variant="outlined"
                          type={passwordparent ? 'password' : 'text'} onKeyPress={handleKeypressparent}
                  name="password"
                  value={parent.password} onChange={changeParentData}

                  error={errorpasswordparent}  placeholder=''

                  helperText={` ${errorpasswordparent == true ? 'Please enter password!' : ''}`}
                               />
                    <span className='login-icon mod-login-icn'><LockIcon /></span>
                        <div className='psd-sec'>
                    <span className="visible-sec" 
                      onClick={() => {handleClickOpenEye()}}
                     style={{display: openEye ? "none" : "block" }}><VisibilityOffIcon /></span>
                    <span className="visible-sec"
                     onClick={() => {handleClickCloseEye()}}
                     style={{display: openEye ? "block" : "none" }}><VisibilityIcon /></span>
                    </div>
                    </Box>
                    <p className="forgot-psd-sec" onClick={handleOpenForgot}>Forgot Password ?</p>


                </div>

                <div className='login-submit mdl-lgn-sbm'>
                    <button className='btn btn-login btn-login-sumt btn-mdl-smt' onClick={handleSubmitParent}>SUBMIT
                     {
                  loaderparent != '' ?
                    <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff", position: 'absolute', marginTop: '3px' }} />
                    : ''

                }
                     </button>
                         {
              loaderparent != '' ? <div className="success-msg success-login success-new-msg">
                <p className="success-msg success-login">Please wait while we get you access to the system</p>

              </div> : <div className="success-msg success-login success-new-msg">
                <p className="success-msg success-login" style={{ visibility: 'hidden' }} >Please wait while we fetch your data</p>
              </div>
            }

            {
              successparentMsg != '' ? <div className="success-msg success-login">
                <p className="success-msg success-login">{successparentMsg}</p>
              </div> : ''
            }


            {
              errorparentMsg != '' ? <div className="error-msg error-login" >
                <p className="error-msg error-login">{errorparentMsg}</p>
              </div> : <div className="error-msg error-login" style={{ visibility: 'hidden' }} >
                <p className="error-msg error-login">Wrong credentials!</p>
              </div>
            }
                </div>

                </div>

            
              </div>
            
             
            </Typography>
          </DialogContent>
        </BootstrapDialog>
        {/* modal section end */}
        
        {/* modal for forgot password start */}
        <BootstrapDialog
          onClose={handleCloseForgot}
          aria-labelledby="customized-dialog-title"
          open={openForgot} className="route-view copy-view logout-view login-modal">
          <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleCloseForgot}>
            {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <Typography gutterBottom>
              <div className='copy-sec-modal logout-sec-modal add-club-sec' style={{ paddingTop: '0px' }}>
                {/* <h2 style={{color:'#57585A',paddingTop:'0px'}}>Logout</h2> */}
              
                <h2>Forgot Password</h2>

                <div className='login-mdl-sec'>

                <div className='login-secs modl-login'>
                    <Box
                        component="form"
                        sx={{
                            '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                        }}
                        noValidate
                        autoComplete="off"
                        >

                        <TextField id="standard-basic" label="Email Id" variant="outlined"
                               value={forgotmail} onChange={changeUserDataFor} onKeyPress={handleKeypressfor}
                  name="forem" />
                    <span className='login-icon mod-login-icn'><MailIcon /></span>
                    </Box>
                </div>
                <div className='login-submit mdl-lgn-sbm'>
                    <button className='btn btn-login btn-login-sumt btn-mdl-smt' onClick={handleSubmitfor}>SUBMIT

                      {
                  loaderforgot != '' ?
                    <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff", position: 'absolute', marginTop: '3px' }} />
                    : ''

                }</button>
                    {
              successMsgforgot != '' ? <div className="success-msg success-login">
                <p className="success-msg success-login">{successMsgforgot}</p>
              </div> : ''
            }


            {
              errorMsgforgot != '' ? <div className="error-msg error-login" >
                <p className="error-msg error-login">{errorMsgforgot}</p>
              </div> : <div className="error-msg error-login" style={{ visibility: 'hidden' }} >
                <p className="error-msg error-login">Wrong credentials!</p>
              </div>
            }
                </div>

                </div>

            
              </div>
            
             
            </Typography>
          </DialogContent>
        </BootstrapDialog>
        {/* modal for forgot password end */}

        {/* modal for reset password start */}
        

        <BootstrapDialog
          onClose={handleCloseReset}
          aria-labelledby="customized-dialog-title"
          open={openReset} className="route-view copy-view logout-view login-modal">
          <BootstrapDialogTitle className="close-routeview" id="customized-dialog-title" onClose={handleCloseReset}>
            {/* <h2 style={{padding:'5px 0px 0px 0px',color:'#ffffff'}}>Logout</h2> */}
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <Typography gutterBottom>
              <div className='copy-sec-modal logout-sec-modal add-club-sec' style={{ paddingTop: '0px' }}>
                {/* <h2 style={{color:'#57585A',paddingTop:'0px'}}>Logout</h2> */}
              
                <h2>Forgot Password</h2>

                <div className='login-mdl-sec'>

                <div className='login-secs modl-login'>
                    <Box
                    component="form"
                    sx={{
                        '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                    }}
                    noValidate
                    autoComplete="off"
                    >

                    <TextField id="standard-basic" label="New Password" variant="outlined"
                        name="username" />
                    <span className='login-icon mod-login-icn'><LockIcon /></span>
                        <div className='psd-sec'>
                            <span className="visible-sec" onClick={handleClickOpenEye} style={{display: openEye ? "none" : "block" }}><VisibilityOffIcon /></span>
                            <span className="visible-sec" onClick={handleClickCloseEye} style={{display: openEye ? "block" : "none" }}><VisibilityIcon /></span>
                    </div>
                    </Box>
                  


                </div>

                
                <div className='login-secs modl-login'>
                    <Box
                    component="form"
                    sx={{
                        '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                    }}
                    noValidate
                    autoComplete="off"
                    >

                    <TextField id="standard-basic" label="Confirm Password" variant="outlined"
                    name="username" />
                    <span className='login-icon mod-login-icn'><LockIcon /></span>
                        <div className='psd-sec'>
                            <span className="visible-sec" onClick={handleClickOpenEye} style={{display: openEye ? "none" : "block" }}><VisibilityOffIcon /></span>
                            <span className="visible-sec" onClick={handleClickCloseEye} style={{display: openEye ? "block" : "none" }}><VisibilityIcon /></span>
                    </div>
                    </Box>
                  


                </div>
                <div className='login-submit mdl-lgn-sbm'>
                    <button className='btn btn-login btn-login-sumt btn-mdl-smt' onClick={handleOpenReset}>SUBMIT</button>
                </div>

                </div>

            
              </div>
            
             
            </Typography>
          </DialogContent>
        </BootstrapDialog>
        {/* modal for reset password end */}
   </>
  )
}

export default Login;